import React from "react";
import { BoxOffers, WindowText } from "..";

const WindowOffers = (data) => {
  if (data.itemsData !== undefined) {
    const offer = [];

    data.itemsData.forEach((item, index) => {
      offer.push({
        id: item.id,
        offerId: `offer_${index}`,
        pictureId: `offer_picture_${index}`,
        name: item.name,
        description: item.description,
        type: data.offer,
        meetingType: item.meeting_type,
        photo_name: item.photo_name,
        image: item.image,
        icon: item.icon,
        background_image: item.background_image,
        changeMethod: data.changeOffer,
        changeBooking: data.changeBooking,
        only_stationary: item.only_stationary,
      });
    });

    return (
      <>
        <div>
          <WindowText
            title={"Oferta dodatkowa"}
            description={` <span>Wybierz, czy chcesz skorzystać z naszej oferty dodatkowej. Poniżej lista usług do wyboru.</span> <br>
              <span>Możesz dowiedzieć się o nich więcej klikając na każdy z kafelków. Pamiętaj, że możesz wybrać <span style="font-weight: bold">tylko 1</span> z usług dodatkowych.</span>`}
            class={"description-2"}
          />
          <div className="offer-section">
            {offer.map((object, index) => (
              <BoxOffers
                index={index}
                id={object.id}
                offerId={object.offerId}
                pictureId={object.pictureId}
                name={object.name}
                description={object.description}
                type={object.type}
                changeMethod={object.changeMethod}
                changeBooking={object.changeBooking}
                meetingType={object.meetingType}
                photo_name={object.photo_name}
                image={object.image}
                icon={object.icon}
                background_image={object.background_image}
                only_stationary={object.only_stationary}
              />
            ))}
          </div>
        </div>
      </>
    );
  } else {
    return <></>;
  }
};

export default WindowOffers;
